<<template>  
  <prop-panel @close="close">
    <p slot="header">{{rs["fillCard"]}}</p>
    
    <div class="row" style="margin-left:0">
        <div class="input-group" style="margin-left:0">
          <span class="input-group-addon" >{{rs["fillDate"]}}</span>
            <date-input :formater='"yyyy-MM-dd"' class="form-control" v-model="fillDate"/>
        </div>
    </div>
    <div class="row" style="margin-left:0; margin-top: 10px;">
      <label><input v-model="fillType" type="radio" name="bkType" checked="checked" value="1">按班次(非班组员工)</label>
      <label><input v-model="fillType" type="radio" name="bkType" value="2">指定班次</label>
      <label><input v-model="fillType" type="radio" name="bkType" value="3">任意时间</label>
        <div v-show="fillType==2" class="input-group">
          <span class="input-group-addon" >班次</span>
          <select class="form-control" v-model="bc">
            <option v-for="item in bcs" :value="item.shiftNo">{{item.shiftName}}</option>
          </select>
        </div>
        
        <div v-show="fillType!=3" class="input-group">
          <span class="input-group-addon" >时间</span>
          <div class="form-control">
            <label><input v-show="fillType!=3" v-model="fcList" type="checkbox" value="1">时间1</label>
            <label><input v-show="fillType!=3" v-model="fcList" type="checkbox" value="2">时间2</label>
            <label><input v-show="fillType!=3" v-model="fcList" type="checkbox" value="3">时间3</label>
            <label><input v-show="fillType!=3" v-model="fcList" type="checkbox" value="4">时间4</label>
            <label><input v-show="fillType!=3" v-model="fcList" type="checkbox" value="5">时间5</label>
            <label><input v-show="fillType!=3" v-model="fcList" type="checkbox" value="6">时间6</label>
            <label><input v-show="fillType!=3" v-model="fcList" type="checkbox" value="7">时间7</label>
            <label><input v-show="fillType!=3" v-model="fcList" type="checkbox" value="8">时间8</label>
          </div>
        </div>
        
        <div v-show="fillType==3" class="input-group">
          <span class="input-group-addon" >时间</span>
            <date-input :formater='"HH:mm"' class="form-control" v-model="fillTime"/>
        </div>
    </div>
    <div class="row" style="margin-left:0; margin-top: 10px;">
      <label><input v-model="fillTarget" type="radio" name="createTypex" value="1" checked="checked">全部</label>
      <label><input v-model="fillTarget" type="radio" name="createTypex" value="2" >按部门</label>
      <label><input v-model="fillTarget" type="radio" name="createTypex" value="3" >按员工</label>

      <div v-show="fillTarget==2" class="input-group">
        <span class="input-group-addon" >部门</span>
          <select name="bmmc" class="form-control" v-model="dept">
            <option v-for="item in depts" :value="item.bmbh">{{item.bmmc}}</option>
          </select>
      </div>
      
      <div v-show="fillTarget==3" style="margin: 1px; height: 190px;" id="selPSx">
        <div v-show="fillTarget==3" class="input-group col-md-10">
          <input ref="gnNo" v-model="gnNo" @keyup.enter="onEnter" type="text" class="form-control">
          <div class="input-group-btn">
            <button @click.stop="onEnter" class="btn btn-default">添加</button>
            <button @click.stop="clear" class="btn btn-default">清除全部</button>
          </div>
        </div>
        <select size="10" name="psSel" style="width: 500px; height: 150px; margin-left:17px;">
          <option v-for="(item, idx) in gnList" :value="item.bh" @dblclick.stop="removeItem(idx)">{{item.bh}}  {{item.xm}}</option>
        </select>
      </div>
    </div>
    <div slot="footer">
      <button @click.stop="close" type="button" class="btn btn-default" data-dismiss="modal">{{rs["btn_close"]}}</button>
      <button @click.stop="fillCard" type="button" class="btn btn-primary">{{rs["fillCard"]}}</button>
    </div>
  </prop-panel>
</template>

<<script>
export default {
  created: function() {
    this.fillDate=$.$DateNow(-1)
  },
  props:["bcs", "depts", "rs", "url"],
  data(){
    return {
      fillDate:null,
      fillDate: "",
      fillType: 1,
      fillTarget: 3,
      gnNo: null,
      fcList:[],
      gnList:[],
      bc:null,
      fillTime: "",
      dept: null
    }
  },
  methods:{
    close: function() {
      this.$emit("close");
    },
    onEnter(){
      if(this.gnList.findIndex(d=>{
        return d.bh==this.gnNo || d.xm==this.gnNo
      }) >= 0 ) {
        this.$refs.gnNo.select()
        return
      } 
      this.$getData(this.url+"GetUser?No=" + this.gnNo + this.$urlSq(), data=>{
        if (data.rs==1){
          this.gnList.push(data.emp)
          this.gnNo=""
          this.$refs.gnNo.select()
        }
        else{
          this.$alert(this.rs["notFound"])
          this.$refs.gnNo.select()
        }
      })
    },
    removeItem(idx){
        this.gnList.splice(idx,1)
    },
    clear(){
       this.gnList = []
       this.$refs.gnNo.select()
    },
    fillCard(){
        if (this.fillType!=3 && this.fcList.length<=0) {
            this.$alert(this.rs["nullTime"])
            return 
        }
        if (this.fillType==2 && !this.bc) {
            this.$alert(this.rs["nullBc"])
            return 
        }
        if (this.fillType==3 && this.$trim(this.fillTime) ==""){
            this.$alert(this.rs["nullTimex"])
            return 
        }
        if (this.fillTarget == 2 && !this.dept){
            this.$alert(this.rs["nullDept"])
            return 
        }
        if (this.fillTarget == 3 && this.gnList.length<=0){
            this.$alert(this.rs["nullGn"])
            return 
        }
        if (this.$trim(this.fillDate) == ""){
            this.$alert(this.rs["nullDate"])
            return 
        }

        const obj = {
            fillType: this.fillType, 
            fillTarget: this.fillTarget,
            fc: this.fcList,
            bc: this.bc,
            fillTime: "1900-01-01 " + this.fillTime + ":00",
            dept: this.dept,
            gn: [],
            fillDate: this.fillDate
        }
        this.gnList.forEach(d=>{
          obj.gn.push(d.bh)
        })

        this.$postData(this.url + "fillCard", obj, data=>{
            if (data.rs == 1) this.$alert(this.rs["msg_action_success"])
            else this.$sysError()
        })

    }
  }
}
</script>
